// extracted by mini-css-extract-plugin
export default {"box":"S0wIRG8Y9V5PvBUePYQQ","row":"lDABf0dqBoLIBbt0pWmO"};